import { matchSorter } from 'match-sorter';

export const useProgramSearch = (
    companyId: MaybeRefOrGetter<number | undefined>,
    exclude?: (id: number) => boolean,
) => {
    const { state, isLoading, execute } = useAsyncState(
        (companyId: number) =>
            companyId == null
                ? Promise.resolve(undefined)
                : api.getPrograms({
                      params: { companyId },
                      queries: {
                          'page[size]': 500,
                      },
                  }),
        undefined,
        {
            resetOnExecute: false,
        },
    );

    watch(
        () => toValue(companyId),
        n => {
            if (n) {
                execute(undefined, n);
            }
        },
        {
            immediate: true,
        },
    );
    const programsFilter = ref<string>();

    const filteredPrograms = computed(() => {
        const result =
            matchSorter(state.value?.data ?? [], programsFilter.value ?? '', {
                keys: ['name'],
            }) ?? [];
        if (exclude) {
            return result.filter(p => !exclude(p.id));
        }
        return result;
    });

    return {
        programs: state,
        isLoadingPrograms: isLoading,
        refreshPrograms: execute,
        programsFilter,
        filteredPrograms,
    };
};
